import { mapActions, mapState } from 'vuex';
import { withMeta } from '@/helpers/dataLayer';
import depositTabs from '@/components/wallet/shared/deposit-tabs/deposit-tabs.vue';
import addFundsCash from '@/components/wallet/add-funds-cash/add-funds-cash.vue';
import addFundsCoinbase from '@/components/wallet/add-funds-coinbase/add-funds-coinbase.vue';
import addFundsBankTransfer from '@/components/wallet/add-funds-bank-transfer/add-funds-bank-transfer.vue';
import addFundsTransfers from '@/components/wallet/add-funds-transfers/add-funds-transfers.vue';
import addFundsCreditCard from '@/components/wallet/add-funds-credit-card/add-funds-credit-card.vue';
import depositPromotionsBanner from '@/components/wallet/shared/deposit-promotions-banner/deposit-promotions-banner.vue';
import feeWaivedBanner from '@/components/wallet/shared/fee-waived-banner/fee-waived-banner.vue';
import loaderMixin from '@/mixins/loader';
import feeWaivedBannerMixin from '@/mixins/feeWaivedBannerMixin';
import depositNotificationsMixin from '@/mixins/depositNotificationsMixin';
import { DEPOSIT_METHOD_TYPE, buildDepositMethodTabs } from '@/components/wallet/shared/depositMethodTypes';

const GTM_PAGE_NAME = 'deposit';

export default {
  mixins: [
    loaderMixin,
    feeWaivedBannerMixin,
    depositNotificationsMixin,
  ],
  components: {
    addFundsCreditCard,
    addFundsCash,
    addFundsCoinbase,
    addFundsBankTransfer,
    addFundsTransfers,
    depositTabs,
    depositPromotionsBanner,
    feeWaivedBanner,
  },
  data() {
    return {
      showTabs: false,
      methods: [],
      activeTab: null,
      cardDepositAttempt: 1,
    };
  },
  computed: {
    ...mapState('wallet', ['depositMethods']),
    showBankingTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.ONLINE_BANKING;
    },
    showCreditCardTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CREDIT_CARD;
    },
    showCashTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CASH;
    },
    showCoinBaseTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.CRYPTO;
    },
    showTransfersTab() {
      return this.activeTab === DEPOSIT_METHOD_TYPE.TRANSFERS;
    },
    tabs() {
      return buildDepositMethodTabs(this.methods);
    },
  },
  watch: {
    depositMethods: {
      immediate: true,
      handler(methods = []) {
        this.methods = [...methods].sort((a, b) => a.tabIndex - b.tabIndex);
      },
    },
  },
  methods: {
    ...mapActions('wallet', ['getDepositMethods']),
    tabChange(name) {
      this.resetChildNotifications();
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent(withMeta({
          event: 'pageviewTrackerEvent',
          virtualPage: `${this.$route.path}/${GTM_PAGE_NAME}/${name}`,
          virtualPageTitle: `${this.$route.name} - ${GTM_PAGE_NAME} - ${name}`,
        }));
      }
    },
    onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getDepositMethods()
      .then(() => {
        this.showTabs = true;
        this.loaderRemove(document.body);
      })
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/deposit/deposit.js